import {Box, LinkButton, Modal, Typography} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {type ReactElement, useCallback} from 'react'

import {EventGoal, useFormUserEventHandler} from '../../../lib/metrika'
import {useBusinessBannerModal} from './hooks'
import * as classes from './Modal.classes'

export type BusinessModalProps = {
  opened: boolean
  onClose: () => void
  utmSource?: string
}

export function BusinessModal(props: BusinessModalProps): ReactElement {
  const {opened, onClose, title, list, description, imageSrc, link} = useBusinessBannerModal(props)
  const i18n = useI18n()

  const handleReachGoal = useFormUserEventHandler()

  const handleRegisterLinkClick = useCallback(() => {
    handleReachGoal(EventGoal.BannerRegistrationButtonClick)
  }, [handleReachGoal])

  return (
    <Modal className={classes.modal} onClose={onClose} opened={opened}>
      <Modal.Header pb="s" pt="xl" />
      <Modal.Body className={classes.body}>
        <Typography group="normal" mb="m" thickness="bold" variant="title3">
          {title}
        </Typography>
        <Typography Component="div" group="loose" variant="body2">
          {description}
        </Typography>
        {list.length > 0 ? (
          <Typography Component="div" group="loose" ml="xl" mt="m" variant="body2">
            <ul>
              {list.map((text, i) => (
                <li key={`business-banner-point-${i}`}>{text}</li>
              ))}
            </ul>
          </Typography>
        ) : null}
        <Box className={classes.image} mt="m" style={{backgroundImage: `url(${imageSrc})`}} />
      </Modal.Body>
      <Modal.Footer>
        <LinkButton href={link} onPress={handleRegisterLinkClick} variant="default" fullWidth>
          {i18n('order.banner.button.register', 'Зарегистрироваться')}
        </LinkButton>
      </Modal.Footer>
    </Modal>
  )
}
